<template>
    <v-container class="pa-6 pa-lg-12 fill-height align-start" fluid>
        <v-btn small outlined color="accent" class="mb-4" @click="$router.go(-1)">
            <v-icon left>mdi-arrow-left</v-icon> Back to mail templates
        </v-btn>
        <v-row>
            <v-col cols="12" md="6" class="d-flex justify-space-between align-center py-0">
                <span class="headline mr-4">Email template translation</span>
            </v-col>
        </v-row>
        <v-card width="920" class="mt-6">
            <v-tabs
                dark
                centered
                background-color="primary"
                v-model="tab"
            >
                <template v-for="(language, index) in languages">
                    <v-tab 
                        :key="index"
                        v-text="language.label"
                        v-if="language.id != defaultLanguage.id"
                    ></v-tab>
                </template>                
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item
                    v-for="(language, index) in languages"
                    :key="index"
                >
                    <div class="pa-4">
                        <v-row>
                            <v-col class="py-0">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details
                                    label="Label"
                                ></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details
                                    label="Subject"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <div class="my-4">
                            <vue-editor :editor-toolbar="customToolbar" />
                        </div>
                        <div class="d-flex">
                            <v-btn
                                small
                                depressed
                                color="primary"
                                @click="translate(language.id)"
                            >Save</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                depressed
                            >Cancel</v-btn>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { VueEditor } from 'vue2-editor'

    export default {
        name: 'mailtemplatesTranslation',
        data: () => ({
            templateId: null,
            tab: 0,
            template: {},
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike', 'link'], 
                [{ 'list': 'ordered'}, { 'list': 'bullet' }]
            ],
            snackbar: {
                show: true,
                message: ''
            }
        }),
        computed: {
            ...mapGetters(['languages', 'defaultLanguage']),
            startingLangugeId() {
                const languages = this.languages.filter(language => language.id != this.defaultLanguage.id)
                return languages[0].id
            }
        },
        components: {
            VueEditor 
        },
        beforeMount() {
            this.templateId = this.$route.params.id
        },
        mounted() {
            this.fetchMailTemplate()
        },
        methods: {
            async fetchMailTemplate() {
                await this.axios.get(`MailTemplate/GetById?id=${this.templateId}&languageId=${this.defaultLanguage.id}`)
                .then(response => {
                    this.template = response.data
                })
                .catch(error => {
                    this.snackbar.message = error
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            translate(languageId) {
                const data = {
                    id: '',
                    name: '',
                    label: '',
                    description: '',
                    languageId: '',
                    subject: ''
                }

                this.axios.post('/MailTemplate/Update', data)
                .then(response => {
                    this.snackbar.message = 'Mail template updated successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>